export default __webpack_public_path__ + "static/location-e574926c1c337ed8769874ab3bd60885.svg";